// Some browsers do not promptly reject an interrupted script download.
// Bound startup independently of the bundler's script timeout.
export function loadApplication(load, timeoutMs = 15000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Application startup timed out')), timeoutMs);
    Promise.resolve().then(load).then(
      value => { clearTimeout(timer); resolve(value); },
      error => { clearTimeout(timer); reject(error); },
    );
  });
}
